export enum RatingStarsMode {
	BLACK,
	ORANGE,
	WHITE,
}

export const STARS_AMOUNT = 5;
